export const SCREEN_TYPE_MEMBER_HOME = 'member-home'
export const SCREEN_TYPE_CENTERS = 'centers'
export const SCREEN_TYPE_WATCH_HISTORY = 'recently-watched'
export const SCREEN_TYPE_SUBCATEGORY = 'subcategory'
export const SCREEN_TYPE_CLASSIC_FACET = 'classic-facet'
export const SCREEN_TYPE_DETAIL_VIDEO = 'video-detail'
export const SCREEN_TYPE_DETAIL_SERIES = 'series-detail'
export const SCREEN_TYPE_SEARCH_PAGE = 'search'
export const SCREEN_TYPE_PLAYLIST = 'playlist'
export const SCREEN_TYPE_RECENTLY_ADDED = 'recently-added'
export const SCREEN_TYPE_SITE_SEGMENT = 'site-segment'
export const SCREEN_TYPE_VIDEO_PLAYER = 'video-player'
export const SCREEN_TYPE_YOGA_TEACHERS = 'yoga-teachers'
export const SCREEN_TYPE_CLE = 'cle'
export const SCREEN_TYPE_YOGA_HOME = 'yoga-home'
export const SCREEN_TYPE_HEADER = 'header'
export const SCREEN_TYPE_FOOTER = 'footer'
export const SCREEN_TYPE_GUIDES = 'guides'
export const SCREEN_TYPE_EVENTS_PLUS = 'events-plus-ma'
export const SCREEN_TYPE_HUBS_PERSONAL_DEVELOPMENT = 'hubs-personal-development'
export const SCREEN_TYPE_HUBS_ANCIENT_WISDOM = 'hubs-ancient-wisdom'
export const SCREEN_TYPE_HUBS_ALTERNATIVE_HEALTH = 'hubs-alternative-health'
